import { useQuery } from '@apollo/client/react';

import { registeredParsersQuery } from '../../services/BulkReparseService';

const DEFAULT_COUNTRY = 'argentina';
const EMPTY_PARSERS = [];

// Providers the backend parser registry has at least one parser for. Source of truth for what
// can actually be reparsed, instead of the frontend's static (and country-agnostic) lists.
// Apollo's cache is shared by every consumer of this hook, so the query only hits the network
// once per session regardless of how many selects mount it.
export const useRegisteredParsers = (country = DEFAULT_COUNTRY) => {
  const { data, loading, error } = useQuery(registeredParsersQuery, {
    variables: { country }
  });

  return {
    registeredParsers: data?.parsers ?? EMPTY_PARSERS,
    loading,
    error
  };
};
